export default __webpack_public_path__ + "static/media/bg_blue_middle.9a9efc13.png";